import Form from '@utils/form'
import http from '@plugin/axios'
import NoEvaluationSysTable from './components/NoEvaluationSysTable.vue'
import EvaluationSystem from './components/hasEvaluationSystem/EvaluationSystem.vue'
import ScoreResult from './components/hasEvaluationSystem/ScoreResult.vue'
import UseRule from './components/hasEvaluationSystem/UseRule.vue'
import ExamineTimeSelector from './components/small/ExamineTimeSelector.vue'
import PurchaseSelector from './components/small/PurchaseSelector.vue'
import AssessSystemSelector from './components/small/AssessSystemSelector.vue'
import { $t } from '@plugin/i18n'

const NO_ASSESS_SYSTEM = '0000'

export function saveCheck(vm: any) {
  if (vm.data.assessSystemNo === NO_ASSESS_SYSTEM && (!Reflect.has(vm.data, 'detailList') || vm.data.detailList.length === 0)) {
    return vm.$message({ message: $t('performanceAppraisal.performanceAppraisal.submitWarn'), type: 'warning' })
  }
  return false
}

const formatterSubmitData = (data: any) => {
  const submitData: any = { ...data }
  if (!Reflect.has(submitData, 'assessSystemName')) {
    submitData['assessSystemName'] = '无'
    submitData['detailList'] = submitData['detailList']['groupData'] || []
  }
  if (submitData.assessSystemNo !== NO_ASSESS_SYSTEM) {
    submitData.examList = submitData.useRule.examList
    submitData.judgeType = submitData.useRule.judgeType
    Reflect.deleteProperty(submitData, 'useRule')
    Reflect.deleteProperty(submitData, 'detailList')
  }
  return submitData
}

// 提交
async function submit(this: any) {
  if (!saveCheck(this)) {
    return http({
      url: '/examineProcess/addExamineProcess',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: formatterSubmitData(this.data),
      loading: true
    })
  }
}

// 提交按钮
function saveAndSubmit(this: any) {
  if (saveCheck(this)) return
  this.submit()
}

async function handleAssessSystem(vm: any) {
  if (vm.data.assessSystemId === NO_ASSESS_SYSTEM) return
  const res: any = await http({
    url: '/examineAssessSystem/getAssessSystem',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { id: vm.data.assessSystemId },
    loading: true
  })
  vm.data.evaluationSystem = res['tabList']
  vm.data.scoreResult = {
    scoreResult: res.scoreResult ?? [],
    examineType: res.examineType ?? ''
  }
  vm.data.useRule = {
    judgeType: res.judgeType ?? '',
    judgeTypeName: res.judgeTypeName ?? '',
    materialCategory: res.materialCategory ?? [],
    examList: res.examList ?? []
  }
  vm.data.workingDateName = res.workingDateName
  vm.data.workingPeriodName = res.workingPeriodName
}

const showEvaluationSystem = (vm: any): any => {
  return Reflect.get(vm.data, 'assessSystemNo') !== NO_ASSESS_SYSTEM
}

const showNoEvaluationSystem = (vm: any): any => {
  return Reflect.get(vm.data, 'assessSystemNo') === NO_ASSESS_SYSTEM
}

const buttons = [
  { type: 'primary', text: 'common.commit', handle: saveAndSubmit },
  { type: 'default', text: 'common.cancel', handle(this: any) { this.$router.back() } }
]

export default new Form('performanceAppraisal.performanceAppraisal')
  .name('PerformanceAppraisal.PerformanceAppraisal.Add')
  .title('formTitle.baseInfo')
  .url(submit)
  .btns(buttons)
  .add('purchaseUnit').required().component(PurchaseSelector)
  .add('assessSystemNo').component(AssessSystemSelector).default('0000').required().on('input', handleAssessSystem)
  .add('workingPeriod').op('examineProcessPeriod').default('1').attrs({ clearable: false }).required().show(showNoEvaluationSystem)
  .formItemComponent('examineMonth', ExamineTimeSelector, {}).required().show(showNoEvaluationSystem)
  .add('workingPeriodName').disabled(true).show(showEvaluationSystem)
  .add('workingDateName').disabled(true).show(showEvaluationSystem)
  .addGroup()
  .formItemComponent('detailList', NoEvaluationSysTable, {}).show(showNoEvaluationSystem)
  .addGroup()
  .formItemComponent('evaluationSystem', EvaluationSystem, []).show(showEvaluationSystem)
  .addGroup()
  .formItemComponent('scoreResult', ScoreResult, {}).show(showEvaluationSystem)
  .addGroup()
  .formItemComponent('useRule', UseRule, {}).show(showEvaluationSystem)
  .end()
